import { useQuery } from '@tanstack/react-query'
import { getAllTeams } from '../../../api/users/getAllTeams'

export const useGetAllTeams = ({ enabled }: { enabled: boolean }) => {
  return useQuery({
    queryKey: ['allAreas'],
    queryFn: getAllTeams,
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 30, // datos permanecen en caché por 30 minutos
    refetchOnMount: true, // revalidar al montar el componente
    refetchOnWindowFocus: false, // no revalidar al enfocar la ventana
    enabled
  })
}